export default __webpack_public_path__ + "assets/images/b1adcee4667ece9f5d89831ee57e69c7.png";